// extracted by mini-css-extract-plugin
export default {"table":"DataIntermittenceTable_table__48y4R","dataIntermittence":"DataIntermittenceTable_dataIntermittence__qxDgg","noData":"DataIntermittenceTable_noData__s+-fX"};